<template>
  <div>
    <label v-if="label && !modelValue && image_path == ''" class="form-label">{{ label }}:</label>
    <div class="form-input p-0" :class="{ error: errors.length }">
      <input ref="file" type="file" :accept="accept" class="hidden" @change="change" />
      <div v-if="!modelValue && image_path == ''" class="p-2">
        <button type="button" class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm" @click="browse">
          {{ $t('message.expense_tickets.select_image') }}
        </button>
      </div>
      <!-- <div v-else class="flex justify-between p-2">
        <img :src="path" alt="Receipt" class="h-50 w-25 object-contain" />
        <button type="button" class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm" @click="remove">Remove</button>
      </div> -->
      <div v-else class="flex items-center justify-center p-2">
        <div @mouseenter="hover = true" @mouseleave="hover = false" class="group relative inline-block">
          <img :src="image_url" alt="Receipt" class="w-80 max-h-96 group-hover:shadow-md object-cover transform group-hover:scale-105 transition-transform" />

          <div v-if="hover" class="absolute inset-0 flex items-center justify-center">
            <button v-if="canUpdate" class="btn-indigo p-2" @click="browse">Edit</button>
            <button v-if="canUpdate" class="btn-danger ml-1 p-2" @click="remove">Delete</button>
            <button class="btn-success ml-1 p-2" @click="openModal()">View</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
    <transition enter-active-class="transition ease-out duration-100" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-in duration-75" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-if="isModalOpen" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center pb-20 pt-4 px-4 min-h-screen text-center sm:block sm:p-0">
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75" />
          </div>
          <div class="inline-block align-bottom text-left bg-white rounded-lg shadow-xl overflow-hidden transform transition-all sm:align-middle sm:my-8 sm:w-full sm:max-w-lg">
            <div class="flex justify-end pt-4 px-4">
              <button class="text-gray-500 hover:text-gray-700 focus:text-gray-700 focus:outline-none" @click="closeModal">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="pb-4 pt-5 px-4 bg-white sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <div class="mt-2">
                    <img :src="image_url" alt="Receipt" class="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: File,
    label: String,
    accept: String,
    canUpdate: {
      type: Boolean,
      default: true,
    },
    image_path: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(value) {
      if (!value) {
        this.$refs.file.value = ''
      }
    },
  },
  mounted() {
    if (this.image_path != '') {
      this.image_url = this.image_path
    }
  },
  data() {
    return {
      image_url: this.image_path,
      hover: false,
      isEnlarged: false,
      isModalOpen: false,
    }
  },
  methods: {
    enlargeImage() {
      this.isEnlarged = !this.isEnlarged
    },
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    browse() {
      this.$refs.file.click()
    },
    change(e) {
      this.$emit('update:modelValue', e.target.files[0])
      let reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (e) => {
        this.image_url = e.target.result
      }
    },
    remove() {
      this.$emit('update:modelValue', null)
      this.image_url = ''
    },
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
  },
}
</script>
